import styled, { css } from 'styled-components/macro';
import { CopyButtonStatusType } from './copy-button';

const ANIMATION_DURATION = 200;

export const Wrapper = styled.button<{ $status: CopyButtonStatusType }>`
  ${({ theme, $status }) => css`
    display: flex;
    column-gap: ${theme.spacings.xs};
    pointer-events: ${$status !== 'idle' ? 'none' : 'auto'};
    color: ${$status === 'copied'
      ? theme.semantic.icon.success
      : $status === 'error'
        ? theme.semantic.icon.error
        : theme.semantic.icon.secondary};
    transition-duration: ${ANIMATION_DURATION / 2}ms;
    cursor: pointer;
    background: none;
    border: none;

    svg {
      path {
        transition-duration: ${ANIMATION_DURATION}ms;
      }
    }
  `}
`;

export const IconWrapper = styled.div`
  position: relative;
  width: 16px;
  height: 16px;

  div {
    position: absolute;
  }

  svg {
    transition-property: opacity, transform;
    transition-duration: ${ANIMATION_DURATION}ms;
    transition-timing-function: ease-in-out;
  }

  .fade-in {
    svg {
      opacity: 1;
      transform: scale(1);
    }
  }

  .fade-out {
    svg {
      opacity: 0;
      transform: scale(0.8);
    }
  }
`;
